import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { getIndexAbove } from "../../utils/reordering/reordering";
import { idValidator } from "../misc/id-validator";
export const PaywallProductValidator = T.model("paywall_product", T.object({
    id: idValidator("paywall_product"),
    typeName: T.literal("paywall_product"),
    identifier: T.string,
    index: T.string
}));
export const Versions = {
    AddIndex: 1
};
const primaryIndex = "a0";
const secondaryIndex = getIndexAbove(primaryIndex);
const tertiaryIndex = getIndexAbove(secondaryIndex);
const idToIndex = {
    [createPaywallProductId("primary")]: primaryIndex,
    [createPaywallProductId("secondary")]: secondaryIndex,
    [createPaywallProductId("tertiary")]: tertiaryIndex
};
export const SWPaywallProductRecordType = createRecordType("paywall_product", {
    migrations: defineMigrations({
        currentVersion: Versions.AddIndex,
        migrators: {
            [Versions.AddIndex]: {
                up: ({ ...rest })=>{
                    const index = idToIndex[rest.id];
                    console.log(`[!] index`, index, rest.id, rest);
                    return {
                        ...rest,
                        index: idToIndex[rest.id]
                    };
                },
                down: ({ index, ...rest })=>({
                        ...rest
                    })
            }
        }
    }),
    validator: PaywallProductValidator,
    scope: "document"
}).withDefaultProperties(()=>({}));
export function isPaywallProduct(record) {
    if (!record) return false;
    return record.typeName === "paywall_product";
}
export function isPaywallProductId(id) {
    if (!id) return false;
    return id.startsWith("paywall_product:");
}
/** @public */ export function createPaywallProductId(id) {
    return `paywall_product:${id ?? nanoid()}`;
}
export function getProductPrefixFromId(id) {
    if (!id) return "";
    return id.split(":")[1];
}
export const castPaywallProductId = (id)=>{
    return {
        toReferenceName () {
            return id.replace(/^paywall_product:/, "");
        }
    };
};
